import { Injectable } from '@angular/core';
import { Statistics } from 'app/trello/models/board-summary';
import { StageChartData } from 'app/trello/models/charts';
import { StatisticsAggregator } from 'app/trello/utility/statistics-aggregator';
import { StructureTransformer } from 'app/trello/utility/structure-transformer';

@Injectable({
  providedIn: 'root'
})
export class StageChartDataAggregator {

  constructor(
    private readonly statisticsAggregator: StatisticsAggregator,
    private readonly statisticsTransformer: StructureTransformer,
  ) {
  }

  public aggregate(
    stats: Statistics,
    aggregationLevel: 'day' | 'week' | 'month' = 'day'
  ): StageChartData {

    const totalStageCardsData =
      this.statisticsAggregator.aggregateCountDistinct(
        stats.stage.total.day || {},
        aggregationLevel,
      );

    const movedIntoStageData =
      this.statisticsAggregator.aggregateCountDistinct(
        this.statisticsTransformer.mergeInnerArrays2D(stats.stage.movedIn) || {},
        aggregationLevel,
      );

    const movedOutOfStageData =
      this.statisticsAggregator.aggregateCountDistinct(
        this.statisticsTransformer.mergeInnerArrays2D(stats.stage.movedOut) || {},
        aggregationLevel,
      );

    const stageDurationData =
      this.statisticsAggregator.aggregateDuration(
        this.statisticsTransformer.collectInnerValues2D(stats.stage.duration) || {},
        aggregationLevel,
      );

    return {
      totalCards: totalStageCardsData,
      movedIn: movedIntoStageData,
      movedOut: movedOutOfStageData,
      duration: stageDurationData,
    };
  }

}
